module.exports = __webpack_public_path__ + "static/media/EruditionMain.cdd75d02.PNG";